import MediaPanelCTAOverlay from "@/components/MediaPanelCTAOverlay";
import cloudflareLoader from "@/lib/cloudflare-images";
import { PlayIcon } from "@heroicons/react/24/solid";
import clsx from "clsx";
import Video from "components/Video";
import Image from "next/legacy/image";
import { useState } from "react";
import { useInView } from "react-intersection-observer";

const MediaPanel = ({
  image,
  brightcoveVideoId,
  priority = false,
  slideshow = false,
  onClick = null,
  showCTAOverlay = false,
}) => {
  const { ref, inView } = useInView({
    threshold: 0.5,
    triggerOnce: !slideshow,
  });

  const [isVideoActive, setIsVideoActive] = useState(false);

  const onClickPlay = () => {
    setIsVideoActive(true);
  };

  const onEnded = () => {
    setIsVideoActive(false);
  };

  return (
    <div
      className={clsx(
        "MediaPanel",
        "group isolate transform-gpu overflow-hidden md:rounded-2xl"
      )}
      ref={ref}
    >
      <div
        className={clsx(
          "MediaPanel__media",
          "relative w-full transition duration-700 ease-out",
          {
            "scale-105 opacity-0": !inView,
            "scale-100 opacity-100": inView,
          }
        )}
      >
        <div
          className={clsx(
            "MediaPanel__imageWrapper",
            "relative aspect-[16/11] overflow-hidden 3xs:aspect-square sm:aspect-square 3xl:aspect-16/11"
          )}
        >
          <div
            className={clsx(
              "MediaPanel__image",
              "absolute inset-0 duration-300 ease-out group-hover:scale-105"
            )}
          >
            {!!image && !!image.url && (
              <Image
                src={image.url}
                layout="fill"
                alt={image.title}
                objectFit="cover"
                sizes="(max-width: 768px) 100vw, 50vw"
                priority={priority}
                loader={cloudflareLoader}
              />
            )}
          </div>
          {showCTAOverlay && <MediaPanelCTAOverlay />}
        </div>

        {brightcoveVideoId && isVideoActive && (
          <div
            className={clsx(
              "MediaPanel__video",
              "absolute inset-0 overflow-hidden rounded-2xl [&>div>video-js]:absolute [&>div>video-js]:inset-0 [&>div>video-js]:h-full [&>div>video-js]:w-full [&>div]:absolute [&>div]:inset-0"
            )}
          >
            <Video
              brightcoveVideoId={brightcoveVideoId}
              playOnMount
              onEnded={onEnded}
            />
          </div>
        )}

        {brightcoveVideoId && !isVideoActive && (
          <div
            className={clsx(
              "MediaPanel__play",
              "absolute inset-0 flex items-center justify-center text-zinc-50 print:!hidden"
            )}
          >
            <button
              onClick={onClick ? onClick : onClickPlay}
              className={clsx(
                "MediaPanel__playButton",
                "flex size-20 items-center justify-center rounded-full border-2 border-current bg-zinc-800/5"
              )}
            >
              <PlayIcon className={clsx("size-10 translate-x-0.5 stroke-1")} />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default MediaPanel;
